import { render, staticRenderFns } from "./objItemData.vue?vue&type=template&id=34b714a0&scoped=true&"
import script from "./objItemData.vue?vue&type=script&lang=js&"
export * from "./objItemData.vue?vue&type=script&lang=js&"
import style0 from "./objItemData.vue?vue&type=style&index=0&id=34b714a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b714a0",
  null
  
)

export default component.exports